import { render } from "./AirMeasurements.vue?vue&type=template&id=12693008"
import script from "./AirMeasurements.vue?vue&type=script&lang=js"
export * from "./AirMeasurements.vue?vue&type=script&lang=js"
script.render = render

export default script